<div class="page layout-page">
  <section class="form-card">
    <h1>{{ eventName }}學校報名登記系統</h1>
    <p>請填寫以下資料來註冊賬戶。</p>
    <div class="already-reg-text">
        <ng-container *ngIf="project=='hklsc_pthyxs'">已報名活動三或曾註冊者，請直接登入：<a href="https://shop.hklsc.net/">https://shop.hklsc.net/</a></ng-container>
        <ng-container *ngIf="project=='hklsc_ccec'">已報名活動二或曾註冊者，請直接登入：<a href="https://shop.hklsc.net/">https://shop.hklsc.net/</a></ng-container>
    </div>
    <form [formGroup]="registrationForm" (ngSubmit)="submit()" novalidate>
      <div class="field-row">
        <label>姓氏 *</label>
        <input formControlName="last_name" placeholder="姓氏" />
        <div class="error" *ngIf="registrationForm.get('last_name')?.touched && registrationForm.get('last_name')?.invalid">請輸入姓氏。</div>
      </div>

      <div class="field-row">
        <label>名字 *</label>
        <input formControlName="first_name" placeholder="名字" />
        <div class="error" *ngIf="registrationForm.get('first_name')?.touched && registrationForm.get('first_name')?.invalid">請輸入名字。</div>
      </div>

      <div class="field-row">
        <label>電郵地址 *</label>
        <input formControlName="email" placeholder="電郵地址" type="email" />
        <div class="error" *ngIf="registrationForm.get('email')?.touched && registrationForm.get('email')?.invalid">請輸入有效電郵。</div>
      </div>

      <div class="field-row">
        <label>手機號碼 *</label>
        <input formControlName="phone" placeholder="手機號碼" />
        <div class="error" *ngIf="registrationForm.get('phone')?.touched && registrationForm.get('phone')?.invalid">請輸入手機號碼。</div>
      </div>

      <div class="field-row">
        <label>密碼 *</label>
        <input formControlName="password" placeholder="密碼" type="password" />
        <div class="error" *ngIf="registrationForm.get('password')?.touched && registrationForm.get('password')?.invalid">密碼最少 6 個字元。</div>
      </div>

      <div class="field-row">
        <label>確認密碼 *</label>
        <input formControlName="verify_password" placeholder="確認密碼" type="password" />
        <div class="error" *ngIf="registrationForm.hasError('passwordMismatch') && registrationForm.get('verify_password')?.touched">密碼不一致。</div>
      </div>

      <div class="field-row">
        <label>學校 *</label>
        <div class="school-dropdown-container" [class.error]="registrationForm.get('affiliation')?.touched && registrationForm.get('affiliation')?.invalid">
          <input
            type="text"
            placeholder="輸入學校名稱"
            [value]="schoolSearch"
            (input)="onSchoolSearch($event.target.value)"
            (focus)="showDropdown = true"
            (blur)="onDropdownBlur()"
          />
          <div class="dropdown-list" *ngIf="showDropdown && filteredSchoolsByRegion.length > 0">
            <div class="region-group" *ngFor="let region of filteredSchoolsByRegion">
              <div class="region-header">{{ region.region }}</div>
              <div class="district-group" *ngFor="let district of region.districts">
                <div class="district-header">{{ district.district }}</div>
                <div class="school-option" *ngFor="let school of district.schools" (click)="selectSchool(school.schoolName)">
                  {{ school.schoolName }}
                </div>
              </div>
            </div>
          </div>
          <div class="no-results" *ngIf="showDropdown && filteredSchoolsByRegion.length === 0 && schoolSearch.trim()">
            沒有找到匹配的學校
          </div>
        </div>
        <div class="error" *ngIf="registrationForm.get('affiliation')?.touched && registrationForm.get('affiliation')?.invalid">請選擇學校。</div>
      </div>

      <div class="field-row checkbox-row">
        <label>
          <input type="checkbox" formControlName="pics" /> 我已閱讀、了解並同意<a href="/assets/tnc.pdf" target="_blank">使用條款及私隱政策。</a>
        </label>
        <div class="error" *ngIf="registrationForm.get('pics')?.touched && registrationForm.get('pics')?.invalid">此項為必填。</div>
      </div>

      <div class="field-row checkbox-row">
        <label>
          <input type="checkbox" formControlName="agree_marketing" /> 我同意訂閱電子報。
        </label>
      </div>

      <div class="actions">
        <button type="submit" [disabled]="submitting">{{ submitting ? '正在提交...' : '提交' }}</button>
      </div>

      <div class="submit-error" *ngIf="submitError">{{ submitError }}</div>
      <div class="already-reg-text-error">
        <ng-container *ngIf="project=='hklsc_pthyxs'">已報名活動三或曾註冊者，請直接登入：<a href="https://shop.hklsc.net/">https://shop.hklsc.net/</a></ng-container>
        <ng-container *ngIf="project=='hklsc_ccec'">已報名活動二或曾註冊者，請直接登入：<a href="https://shop.hklsc.net/">https://shop.hklsc.net/</a></ng-container>
      </div>
    </form>
  </section>
</div>
